import { SidebarTable } from './SidebarTable';
import styled from 'styled-components/macro';
import { fontSize01, fontSize08 } from '../../../styling/fonts';

type JobReferenceProps = {
  reference: string;
  currentRevision: string;
};
export const JobReference = ({ reference, currentRevision }: JobReferenceProps) => {
  const displayRevision = currentRevision.split(' ')[1];

  return (
    <SidebarTable>
      <thead>
        <SmallTextTr>
          <th colSpan={4}>Job Reference</th>
          <th>Rev</th>
        </SmallTextTr>
      </thead>
      <tbody>
        <LargeTextTr>
          <td colSpan={4}>QR{reference}</td>
          <td>{displayRevision}</td>
        </LargeTextTr>
      </tbody>
    </SidebarTable>
  );
};

const SmallTextTr = styled.tr`
  th {
    padding: 4px;
    font-size: ${fontSize01};
    border: 1px solid black;
  }
`;

const LargeTextTr = styled.tr`
  td {
    font-size: ${fontSize08};
    border: 1px solid black;
  }
`;
